import { render } from "./AccessibilityPanel.vue?vue&type=template&id=066b4ae3"
import script from "./AccessibilityPanel.vue?vue&type=script&lang=js"
export * from "./AccessibilityPanel.vue?vue&type=script&lang=js"

import "./AccessibilityPanel.vue?vue&type=style&index=0&id=066b4ae3&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__